export const comments_5519470 = {"data":{"data":[],"links":{}}}